module.exports = __webpack_public_path__ + "media/images/featuredon_techcrunch-49ce0a89.png";